import { ReactNode } from "react";

// ENG-2535: the classic rail's row content, kept verbatim while the redesign is behind the
// `sidebar-redesign` flag. Delete this folder with the flag.

import Badge from "@mui/material/Badge";
import ListItemIcon from "@mui/material/ListItemIcon";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import BottomRightDotBadge from "components/bottom-right-dot-badge/bottom-right-dot-badge.component";

type LegacySideMenuItemContentProps = {
  isActive: boolean;
  primary: string;
  Icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {
    muiName: string;
  };
  badgeContent?: ReactNode;
  isDotWarning?: boolean;
  allowWrap?: boolean;
};

export default function LegacySideMenuItemContent({
  isActive,
  primary,
  Icon,
  badgeContent,
  isDotWarning,
  allowWrap = false
}: LegacySideMenuItemContentProps) {
  const theme = useTheme();

  return (
    <>
      <ListItemIcon
        sx={{
          minWidth: 0,
          justifyContent: "center"
        }}
      >
        <Badge badgeContent={badgeContent} color="primary" sx={{ zIndex: 0 }}>
          {isDotWarning ? (
            <BottomRightDotBadge
              badgeContent={isDotWarning ? "1" : undefined}
              variant="dot"
            >
              <Icon
                sx={{
                  color: isActive
                    ? theme.palette.common.white
                    : theme.palette.neutral[500]
                }}
              />
            </BottomRightDotBadge>
          ) : (
            <Icon
              sx={{
                color: isActive
                  ? theme.palette.common.white
                  : theme.palette.neutral[500]
              }}
            />
          )}
        </Badge>
      </ListItemIcon>

      <Typography
        sx={{
          display: allowWrap ? "block" : "flex",
          alignItems: "center",
          textAlign: "center",
          fontSize: "16px",
          lineHeight: allowWrap ? 1.1 : 1,
          fontWeight: isActive ? "fontWeightBold" : "fontWeightRegular",
          textDecoration: "none",
          whiteSpace: allowWrap ? "normal" : "nowrap",
          height: allowWrap ? "auto" : "22px",
          color: isActive
            ? theme.palette.common.white
            : theme.palette.neutral[500]
        }}
      >
        {primary}
      </Typography>
    </>
  );
}
